<div class="service-provider">
    <div class="mainWrap">
        <div class="headerSection">
            <div class="titleWrap">
                Why Choose us ?
            </div>
            <div class="subTitleWrap">
                We work selflessly “To serve established and emerging organisations with the best IT services to help them achieve their ultimate goals.”
            </div>
            <div class="descWrap">
                We design meaningful digital products & experiences for people. We leave no stone unturned while working so that we can deliver our clients the best. It makes us feel highly proud and encouraged when our clients appreciate our work.
            </div>
        </div>
        <div class="bodySection">
            <div class="rowWrap" *ngFor = "let i of services">
                <div class="card">
                    <div class="imageWrap">
                        <img src="{{i.imageUrl}}">
                    </div>
                    <div class="textWrap">
                        <div class="titleRowWrap">
                           {{i.title}}
                        </div>
                        <div class="descRowWrap">
                           {{i.desc}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>